import { TimeRange } from './time-range';
import { SourceType } from 'src/app/control-bar-type-selector/model/source-type';
import { SearchFilter } from './search-filter'
export class SearchRequestNg {
    queryString: string = '';
    timeRange: TimeRange = new TimeRange();
    typeMapping: Array<SourceType> = [];
    drillDownFilters: Array<DrillDownFilter> = [];
    filters: Array<SearchFilter> = [];
}


export class DrillDownFilter {
    serieId: string = null;
    levels: Array<DrillDownLevel> = [];
}



export class DrillDownLevel {
    current: boolean = false;
    keys: Array<string> = [];
}